import React from 'react';
import styles from "../../../styles/applicant/ApplicantTable.module.css";

const LoadingState = () => {
    return (
        <div className={styles.loadingState}>
            <div className={styles.loadingSpinner} />
        </div>
    );
};

export default LoadingState;